import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { formatDate } from 'lib/functions/utils';
import React from 'react';

type EditOperationDateDialogProps = {
  open: boolean;
  onClose: () => void;
  operationDate?: Date;
  setOperationDate: (newDate: Date) => void;
};

function EditOperationDateDialog({
  open,
  onClose,
  operationDate,
  setOperationDate,
}: EditOperationDateDialogProps) {
  const handleEditOperationDate = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const inputDate = new Date(event.target.value);
    inputDate.setUTCHours(12);
    setOperationDate(inputDate);
    onClose();
  };
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Editar fecha de solicitud</DialogTitle>
        <DialogContent style={{ paddingTop: 12 }}>
          <Typography
            sx={{
              color: 'warning.main',
              display: 'block',
              marginBottom: 2,
            }}
          >
            ⚠️ Al editar la fecha de solicitud pueden{' '}
            <strong>cambiar los saldos de documentos aplicados</strong>. Se
            recomienda revisar los montos aplicados en la solicitud ya que estos
            no se actualizan automáticamente a la nueva fecha.
          </Typography>
          <TextField
            fullWidth
            label="Fecha de solicitud"
            type="date"
            value={operationDate ? formatDate(operationDate) : null}
            onChange={handleEditOperationDate}
          />
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={onClose}>
            Cerrar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditOperationDateDialog;
